angular.module('cfn').service('cultureSearch.service', cultureSearchService);
cultureSearchService.$inject = ['$rootScope', '$log', '$q', '$http'];

function cultureSearchService($rootScope, $log, $q, $http) {
  const CULTURE_SERVICE_BASE_URL = '/365FarmNet/mod/supply-service/rest/v1.0/seeds/cultures';
  const CULTURE_SERVICE_SYSCULTURE_URL = '/365FarmNet/rest/core/sysculture/';

  let cultureSearchService = {
    getAllCultures: getAllCultures,
    getSysCulture: getSysCulture,
  };
  return cultureSearchService;


  // --- public methods --------------------------------------------------------------------------
  function getAllCultures(text) {

      return $http.get(CULTURE_SERVICE_BASE_URL).then(
        (response) => {
          if(response.data) {
              return {
                  searchString: text,
                  results: response.data.filter((item) => {
                      return (item.name && item.name.toLowerCase().includes(text.toLowerCase()));
                  }),
              };
            //return response.data;
          } else {
              return {
                  searchString: text,
                  results: [],
              }
            // return [];
          }
        },
        (errorResponse) => {
          $log.error('Error getting all cultures for user from backend: ', errorResponse);
          return [];
        });
  };

  function getSysCulture(id) {
      return $http.get(CULTURE_SERVICE_SYSCULTURE_URL + id).then(
          (response) => {
              return response;
      },
      (errorResponse) => {
          $log.error('Error getting cultures for user from backend: ', errorResponse);
          return [];
      });
  };


};

export default cultureSearchService;
